import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { OficinaService } from '../services/oficina.service';
import { ExcelService } from '../services/excel.service';
import Swal from 'sweetalert2';

import { ActivatedRoute, Router } from "@angular/router";
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-oficinas',
  templateUrl: './oficinas.component.html',
  styleUrls: ['./oficinas.component.css'],
  animations: [loadingFade]
})
export class OficinasComponent implements OnInit {
	public loading = false;
	public oficinas = [];
	public bairro_array = [];

	// paginacao
	public page = 1;
	public limit = 10;
  	public count = 0;

	//acesso
	public menu_id = 126; //Cadastro - ADM
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	

  
	constructor(private oficinaSvc: OficinaService,
				private excelSvc: ExcelService,
				private route: ActivatedRoute,
				private perfilUsuarioSvc: PerfilUsuarioService,
				private authSvc: AuthService) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 

		this.pegaOficinas();
	}

  	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	pegaOficinas(){

		var loOficina_endereco = "";
		var loOficina_endereco_numero = "";
		var loOficina_bairro = "";
		var loOficina_municipio = "";
		var loOficina_uf = "";

		this.oficinas = [];
		this.loading = true;
		this.oficinaSvc.getOficinas().then((data: any[]) => {
			this.oficinas = data;
			this.count = this.oficinas.length;
			for(let index in this.oficinas)
			{
				console.log("[oficina_endereco = ] ", this.oficinas[index].oficina_endereco );
				if( this.oficinas[index].oficina_endereco === null){
					loOficina_endereco = "" 
				}else{
					loOficina_endereco = this.oficinas[index].oficina_endereco;
				}

				if( this.oficinas[index].oficina_endereco_numero === null){
					loOficina_endereco_numero = "" 
				}else{
					loOficina_endereco_numero = ' n.' + this.oficinas[index].oficina_endereco_numero + ', ';
				}

				if( this.oficinas[index].oficina_bairro === null){
					loOficina_bairro = "" 
				}else{
					loOficina_bairro = this.oficinas[index].oficina_bairro + ', ';
				}		
				
				if( this.oficinas[index].oficina_municipio === null){
					loOficina_municipio = "" 
				}else{
					loOficina_municipio = this.oficinas[index].oficina_municipio + ', ';
				}					

				if( this.oficinas[index].oficina_uf === null){
					loOficina_uf = "" 
				}else{
					loOficina_uf = this.oficinas[index].oficina_uf;
				}					

				this.oficinas[index]['address'] = loOficina_endereco +
				loOficina_endereco_numero + 
				loOficina_bairro + 
				loOficina_municipio + 
				loOficina_uf;
			}
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	apagaOficina(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.oficinaSvc.apagaOficina(id).then((data) => {
					this.pegaOficinas();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	exportarExcel(){
		let data = [];
		for(let index in this.oficinas){
			data[index] = {
				'Oficina': this.oficinas[index].oficina_nome,
				'Endereço': this.oficinas[index].oficina_endereco +
							' n.' + this.oficinas[index].oficina_endereco_numero + ', ' +
							this.oficinas[index].bairro.bairro_nome + ', ' +
							this.oficinas[index].municipio.municipio_nome + ', ' +
							this.oficinas[index].uf.uf_nome,
				'CEP': this.oficinas[index].oficina_cep,
				'CNPJ': this.oficinas[index].oficina_cnpj
			};
		}

		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Oficinas de Combustível');
	}
}
